import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Banner from "../../components/Banner/Banner";
import AsideBox from "../../components/AsideBox/AsideBox";
import CareerDetailsData from "../../json/careerdetailspage.json";
import JobSearchData from "../../json/jobSpecification.json";
import MetaTag from "../../components/MetaTag/MetaTag";
import CareerPageData from "../../json/careerpage.json";
import axios from "axios";
import DecryptData from "../../service/DecryptData";
import CareerPageListData from "../../json/careerpage.json";
import JobGoogleAD from "../../json/jobGoogleAD.json";
interface KeyValue {
    key?: string;
    value: string;
}
interface Job {
    jobId: string;
    jobTitle: string;
    jobDescription: string;
    location: string;
    jobCategory: string;
    jobType: string,
    workProfile: string,
    experience: string,
    noOfOpenings: number,
    keyResponsibility: KeyValue[],
    technologySkills: KeyValue[],
    requiredQualification: KeyValue[],
    workingConditions?: KeyValue[],
    ourDetails: string,
    ourOffer: KeyValue[],
    additionalInformation: KeyValue[],
    status: string,
    effectiveFrom: string,
    effectiveTo: string,
    createdOn: string,
    jobOpeningId?: string,
    jobUrl?: string
}

const careerDetailsBanner = CareerDetailsData.bannerSection;
const careerList = CareerPageListData.jobTileSection;
const careerListFilter = careerList.map(job => ({
    jobTitle: job.title,
    url: job.url
}));
const careerJobGoogleAD = JobGoogleAD.jobIdList;

const CareerDetail = () => {
    const [jobSpecification, setJobSpecification] = useState<Job[]>([]);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        const fetchJobDescription = async () => {
            const apiUrl = process.env.REACT_APP_READ_ZOHO_JOBPOSTING || "";
            const requestId = process.env.REACT_APP_JOB_REQUEST_KEY || "";
            await axios.get(apiUrl,
                {
                    headers: {
                        'authorizationToken': `${requestId}`
                    }
                }
            ).then((data) => {
                if (data.data.statusCode == 200) {
                    //const secretKey = process.env.REACT_APP_JOB_REQUEST_KEY || "";
                    const parseData = JSON.parse(data.data.body);                    
                    const jobData = JSON.parse(parseData.data);
                   if(queryParams.size > 0){
                        const decryptedData = DecryptData(queryParams.get('source') || "", process.env.REACT_APP_CAREER_KEY || "");
                        if(decryptedData.toLocaleLowerCase() === "googleadservice"){
                            const filteredJobslist = careerJobGoogleAD.toString().split(",");
                            const filteredJobs = jobData.jobs.filter((job: any) => filteredJobslist.includes(job.jobId));
                            setJobSpecification(filteredJobs);
                        }                        
                    }else{
                        setJobSpecification(jobData.jobs.filter((job: any) => job.status === "Published"));
                    }
                }
            });
        };
        fetchJobDescription();
    }, []);

    const { jobId,jobTitle } = useParams();
    const zohoRecruitAPI = process.env.REACT_APP_ZOHO_RECRUIT_URL;
    const jobSearchResult = jobSpecification?.filter((job) => job.jobId.includes(jobId || ''));
    const similerJobSearchResult = jobSpecification?.filter(item => item.jobId !== jobId);
    const jobBannerText =
    {
        "id": jobSearchResult[0]?.jobId,
        "title": jobSearchResult[0]?.jobTitle,
        "location": jobSearchResult[0]?.location,
        "designation": jobSearchResult[0]?.workProfile,
        "jobCount": jobSearchResult[0]?.noOfOpenings,
        "jobOpeningId": jobSearchResult[0]?.jobOpeningId,
        "jobUrl": jobSearchResult[0]?.jobUrl,
    };
    const handleBannerSearchText = (searchValue: any) => {
        console.log("searchValue", searchValue);
    };
    const handleApplyNow = () => {        
        if(queryParams.size > 0){
            const sourceValue = DecryptData(queryParams.get('source') || "", process.env.REACT_APP_CAREER_KEY || "");
            const parsedUrl = new URL(jobSearchResult[0]?.jobUrl || "");
            const qParams = new URLSearchParams(parsedUrl.search);
            qParams.set('source',sourceValue || "");
            parsedUrl.search = decodeURIComponent(qParams.toString());
            window.open(parsedUrl.toString(), "_blank", 'noopener,noreferrer');
        }
        else{
            window.open(jobSearchResult[0]?.jobUrl, "_blank", 'noopener,noreferrer');
        }
    }
    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };
    const removeInlineStyles = (htmlContent:any) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
      
        // Loop through all elements and remove their inline styles
        const elements = tempDiv.querySelectorAll('*');
        elements.forEach((element) => {
          element.removeAttribute('style');
          element.removeAttribute('class');
        });
      
        return tempDiv.innerHTML;
      };
    return (
        <>
            <MetaTag title={`${jobTitle} ${jobId}`} description={CareerPageData.description} jobTitle={jobTitle} />

            <Banner
                isCarousle={false}
                bannerCardPosition={"center"}
                bannerCardColor={""}
                bannerImages={careerDetailsBanner}
                stretchFullWidth={true}
                bannerClass={""}
                bannerJobContentFlag={true}
                bannerJobContent={jobBannerText}
                handleBannerSearchText={handleBannerSearchText}
            />
            {jobSearchResult.length > 0 ? (
                <>
                    <div className="bgWhite pad-15-xs">
                        <div className="container liquid-container">
                            <div className="spacer30"></div>
                            <div className="inline-blck w-100">

                                <div className="right-blck w-70 w-sm-60  pad-right-20 pad-right-20-md pad-15-right-sm w-100-xs pad-top-20-xs">
                                    <a href="#" onClick={handleBack}>
                                        <img
                                            style={{ marginTop: '-3px' }}
                                            alt="big-back-arrow.png"
                                            src="/content/img/big-back-arrow.png"
                                        />
                                        <span style={{ marginLeft: '10px' }}>Back</span>
                                    </a>
                                    <div className="spacer30"></div>
                                    <div className="zoho-content" dangerouslySetInnerHTML={{ __html: removeInlineStyles(jobSearchResult[0].jobDescription.replace("<h3>Requirements</h3>", "").replace("<h3>Benefits</h3>", "")) }}></div>
                                </div>

                                <div className="left-blck w-30 w-sm-40  w-100-xs">
                                    <AsideBox
                                        title="Similar Jobs"
                                        description=""
                                        subTitle=""
                                        fullLine={true}
                                        asideBoxButtonClass="career-banner-search-box"
                                        asideBoxButton={false}
                                        asideBoxButtonText="Submit"
                                        asideBoxInputClass="career-banner-search-input"
                                        asideBoxInputPlaceHolder=""
                                        asideBoxEmail={false}
                                        customBodyClass={"bgGray19 contentBox-description-sm"}
                                        asideList={true}
                                        asideListDetails={similerJobSearchResult}
                                        asideListDetailsLink={careerListFilter}
                                        asideSocialIcons={false}
                                        asideSocialTitle=""
                                        asideBoxItemShowLength={3}
                                        asideBoxFolderIcon={true}
                                        asideBoxLocationIcon={false}
                                    />

                                    <AsideBox
                                        title="Share this opportunity"
                                        description=""
                                        subTitle=""
                                        fullLine={false}
                                        asideBoxButtonClass="career-banner-search-box"
                                        asideBoxButton={false}
                                        asideBoxButtonText="Submit"
                                        asideBoxInputClass="career-banner-search-input"
                                        asideBoxInputPlaceHolder=""
                                        asideBoxEmail={false}
                                        customBodyClass={"bgGray19 mar-top-15  pad-30  contentBox-description-sm"}
                                        asideList={false}
                                        asideListDetails={[]}
                                        asideListDetailsLink={[]}
                                        asideSocialIcons={true}
                                        asideSocialTitle={jobSearchResult[0].jobTitle}
                                        asideBoxItemShowLength={2}
                                        asideBoxFolderIcon={false}
                                        asideBoxLocationIcon={false}
                                    />
                                </div>                                
                            </div>

                            <div className="spacer20"></div>
                            <hr className="footer-line"></hr>
                            <div className="spacer30"></div>
                            <div className="txtCenter-xs">
                                <a href="javascript:void(0)" id="btn-apply" 
                                onClick={(e) => { 
                                    (window as any).dataLayer = (window as any).dataLayer || [];
                                    function gtag(...args: any[]){(window as any).dataLayer.push(args)};
                                    gtag({event: 'subscribe_click', 
                                        event_category: 'engagement',
                                        event_label: 'Apply Button',
                                        value: jobTitle,
                                    });
                                    handleApplyNow() }} 
                                className="btn btn-default" target="_blank">{careerDetailsBanner[0].buttonText}</a>                                
                            </div>


                        </div>
                    </div>
                </>
            ) :
                (
                    <>
                        <div id="brf-page-loader" className="loader-fixed bgWhite container-flex-box brf-page-loader">
                            <img src="/content/img/loader.gif"/>
                            <div className="page-loader-msg middle-align-self pad-left-10">Loading data, please wait</div>
                        </div>
                    </>
                )}
        </>);
};

export default CareerDetail;